import { Link } from "react-router-dom";

import type { Id, PresenceEntry } from "../../../api/types";
import { Card, EmptyState } from "../../../ui";
import { describePresence, othersOnline } from "../model/people";
import { navigatorHref } from "../model/words";

interface WorkingNowProps {
  entries: readonly PresenceEntry[];
  ownMembershipId: Id | null | undefined;
  /** The name of an item, when the tree knows it. */
  nameOf(id: Id): string | undefined;
}

/** Who is working on what right now. The live channel keeps it current. */
export function WorkingNow({ entries, ownMembershipId, nameOf }: WorkingNowProps) {
  const others = othersOnline(entries, ownMembershipId);
  return (
    <Card aria-labelledby="working-title" className="nv-working">
      <h2 id="working-title">Who is working on what</h2>
      {others.length === 0 ? (
        <EmptyState title="Nobody else is online">When a colleague opens the app, you see here where they are working.</EmptyState>
      ) : (
        <ul>
          {others.map((entry) => {
            const itemName = entry.item_id ? nameOf(entry.item_id) : undefined;
            return (
              <li key={entry.membership_id}>
                <strong>{entry.display}</strong> is {describePresence(entry, itemName)}
                {entry.item_id && itemName && (
                  <>
                    {" "}
                    <Link to={navigatorHref(entry.item_id)}>Show in the tree</Link>
                  </>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </Card>
  );
}
